import { TranslationMap } from '@trimble-gcs/i18n-types';

export function connectFilePickerTranslations() {
  return {
    title: {
      text: $localize`:@@import.dialog.picker.connect.title:Import File(s) From Connect`,
      desc: 'Title for the Connect file picker dialog.',
    },
    close: {
      tooltip: {
        text: $localize`:@@import.dialog.picker.connect.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the Connect file picker dialog.',
      },
    },
    projectSelect: {
      label: {
        text: $localize`:@@import.dialog.picker.connect.projectSelect.label:Connect Project`,
        desc: 'Label next to the selected Connect project name.',
      },
      tooltip: {
        text: $localize`:@@import.dialog.picker.connect.projectSelect.tooltip:Select Connect project`,
        desc: 'Tooltip for the button that opens the Connect project picker.',
      },
    },
    selectedQty: {
      '=1': {
        text: $localize`:@@import.dialog.picker.connect.selectedOne:1 file selected`,
        desc: 'Text to display when user has one file selected.',
      },
      other: {
        text: $localize`:@@import.dialog.picker.connect.selectedMany:{count} files selected`,
        desc: 'Text to display when user has more than one file selected.',
      },
    },
    errorGettingFileInfo: {
      text: $localize`:@@import.dialog.picker.connect.errorGettingFileInfo:Error getting file information`,
      desc: 'Error message displayed when file info could not be retrieved.',
    },
    cancel: {
      text: $localize`:@@import.dialog.picker.connect.cancel:Cancel`,
      desc: 'Button text to close and dismiss the Connect file picker dialog.',
    },
    next: {
      text: $localize`:@@import.dialog.picker.connect.next:Next`,
      desc: 'Button text to continue after selection has been made.',
    },
  } satisfies TranslationMap;
}
